// Autosave form 
var AutoSave = {

  form: null,
  formLength: null,
  interval: null,
  contentChanged: false,
  formSubmitting: false,
  latestSave: null,
  saveLongTextField: false,
  keyPressedOnLongText: false,


  init: function(){
    AutoSave.stop(); // Just making sure
    AutoSave.form = jQuery('form.autosave');
    // AutoSave.formLength = AutoSave.form.find('input, select, textarea, option').not('[type="hidden"]').length;

    if (AutoSave.form.length > 0) {

      AutoSave.renderUpdatedFields();

    //   clearInterval(AutoSave.interval);
    //   setTimeout( function() { // Just to make sure that form is rendered completely
    //     AutoSave.interval = setInterval(AutoSave.save, 2000);
    //   }, 3000);


    //   AutoSave.form.on('submit', 'form', function(event) {
    //     AutoSave.formSubmitting = true;
    //     AutoSave.contentChanged = false;
    //   });

    //   AutoSave.form.on('click', '.btn', function(){
    //     AutoSave.formSubmitting = true;
    //     AutoSave.contentChanged = false;
    //   })

    //   AutoSave.form.find(':input').not('[type="hidden"]').on('change dp.change', function(event){
    //     AutoSave.contentChanged = true;
    //     AutoSave.formSubmitting = false;
    //   });

    //   // Save the form every 30s when editing long text fields. Change -event only triggers on field blur
    //   AutoSave.form.find('textarea, input[type="text"]').on('focus', function(event){
    //     AutoSave.formSubmitting = false;
    //     AutoSave.longTextInterval = setInterval(function(){
    //       AutoSave.saveLongTextField = true
    //     }, 30000);
    //   });

    //   // Clear the interval on blur. The form will be saved by change event
    //   AutoSave.form.find('textarea, input[type="text"]').on('blur', function(event){
    //     clearInterval(AutoSave.longTextInterval);
    //   });
        
    //   // Keep track of keypresses on form field.
    //   AutoSave.form.find('textarea, input[type="text"]').on('keypress', function(event){
    //     AutoSave.keyPressedOnLongText = true
    //   });
      
    }

    // // Render error marker to load fontawesome font, so that it can be shown once offline.
    jQuery('.autosave-status p').addClass('error');
    jQuery('.autosave-status p').addClass('invisible');
    jQuery('.autosave-status p').tooltip();

    jQuery('#confirm-autosave').on('click', AutoSave.hideAutoSaveInformation)
  },


  stop: function(){
    clearInterval(AutoSave.interval);
  },


  save: function(){

    // //Form is being submitted by clicking save.
    // if (AutoSave.formSubmitting) {
    //   return
    // }

    // AutoSave.form = jQuery('form.autosave');

    // // Stop autosaving when form is not visible
    // if (AutoSave.form.length < 1) {
    //   AutoSave.stop();
    //   return;
    // }

    // // Form has no action defined.
    // if (!AutoSave.form.attr('action')){
    //   AutoSave.stop();
    //   return;
    // }

    // var currentLength = AutoSave.form.find('input, select, textarea, option').not('[type="hidden"]').length;

    // // Content changed (or new input field added), autosave
    // if (AutoSave.contentChanged || currentLength !== AutoSave.formLength || (AutoSave.saveLongTextField && AutoSave.keyPressedOnLongText)) {

    //   //console.log('Autosaving because contentChanged: ' + AutoSave.contentChanged)
    //   //console.log('Autosaving because form length changed: ' + (currentLength !== AutoSave.formLength));
    //   //console.log('Autosaving because long text field edited: ' + (AutoSave.saveLongTextField && AutoSave.keyPressedOnLongText));

    //   AutoSave.formLength = currentLength
    //   AutoSave.contentChanged = false;
    //   AutoSave.saveLongTextField = false;
    //   AutoSave.keyPressedOnLongText = false;

    //   var form = AutoSave.form;

    //   jQuery.ajax({
    //     url: form.attr('action'),
    //     method: 'POST',
    //     data: form.serialize() + '&status=autosave',
    //     success: function(data, textStatus){
    //       if (data.status === 'login-required') {
    //         // Auto save failed.
    //         // Render login, once user has logged in set to true
    //         AutoSave.contentChanged = true;
    //         AutoSave.updateSaveStatus('session_error');
    //       } else {
    //         AutoSave.updateSaveStatus('success');
    //         var currentdate = new Date(); 
    //         AutoSave.latestSave = currentdate.toLocaleTimeString();
    //       }
    //     },
    //     error: function(XMLHttpRequest, textStatus, errorThrown){
    //       // Auto save failed.
    //       AutoSave.contentChanged = false;
    //       if (XMLHttpRequest.status === 422){
    //         AutoSave.contentChanged = true;
    //         AutoSave.updateSaveStatus('session_error');
    //       }
    //       else if (XMLHttpRequest.readyState == 4) {
    //         // HTTP error (i.e. 500, 502 etc...)
    //         AutoSave.updateSaveStatus('http_error')
    //       }
    //       else if (XMLHttpRequest.readyState == 0) {
    //         // Network error (i.e. connection refused, access denied due to CORS, etc.)
    //         AutoSave.updateSaveStatus('connection_error');
    //         // Keep polling until fixed.
    //         AutoSave.contentChanged = true;
    //       }
    //       else {
    //         AutoSave.updateSaveStatus('unexpected_error')
    //       }
    //     }
    //   })
    // }
  },


  updateSaveStatus: function(status){
    var statusElem = jQuery('.autosave-status p');
    statusElem.removeClass('invisible');
    statusElem.removeClass('error');


    var latestSave = AutoSave.latestSave ? ( '. ' + I18n.t('latest_save') + ' ' + AutoSave.latestSave) : ''

    switch(status) {
      case 'http_error':
      case 'connection_error':
      case 'unexpected_error':
        statusElem.html(I18n.t(status) + latestSave);
        statusElem.attr('title', I18n.t(status + '_info'));
        statusElem.addClass('error');
        statusElem.tooltip('fixTitle');
        break;
      case 'session_error':
        statusElem.html(I18n.t(status) + latestSave);
        statusElem.addClass('error');
        AutoSave.contentChanged = false;

        // Render login dialog
        SmartME.renderLoginDialog(function(){
          AutoSave.contentChanged = true;
        });
        break;
      default: 
        statusElem.html('')
        statusElem.removeClass('error');
    }
  },


  renderUpdatedFields: function() {

    if (jQuery('#autosave-diff').length < 1) {
      return;
    }

    var diff = JSON.parse(jQuery('#autosave-diff').text());

    if (diff !== null) {
      diff.forEach(function(d){
        diffInChild = []
        if (typeof d.current === 'object'){
          for (var propName in d.current) {
            if (d.previous && d.current[propName] != d.previous[propName]){
              diffInChild.push(propName);
            }
          }
        }
   
        if (diffInChild.length > 0){
          diffInChild.forEach(function(dc){
            var input_elem = jQuery('[name*="' + d.key + '"]').filter('[name*="' + dc + '"]');
            input_elem.addClass('recovered');
          });
        } else {
          var input_elem = jQuery('[name*="' + d.key + '"]');
          input_elem.addClass('recovered');
        }
      })
    }
  },


  hideAutoSaveInformation: function(e) {
    e.preventDefault();
    jQuery('.autosave-alert').remove();
    jQuery('input, select, textarea, option').removeClass('recovered');
    return false;
  }

}


var ConfirmFormExit = {
    contentOnLoad: null,
    formSubmitting: false,
    initialized: false,
    published: false,

    init: function() {
        // console.log("init " + ConfirmFormExit.initialized)

        jQuery('.main').on('click', 'form.confirm-exit', function(){

          ConfirmFormExit.formSubmitting = false;

          jQuery('form.confirm-exit').on('submit', function(event) {
            // console.log("submit")
            // console.log(ConfirmFormExit.serializeForm())
            // Update content on submit
            ConfirmFormExit.formSubmitting = true;
            ConfirmFormExit.contentOnLoad = ConfirmFormExit.serializeForm();
          });

          jQuery('form.confirm-exit [type="submit"]').on('click', function(){
            // console.log("click")
            // console.log(ConfirmFormExit.serializeForm())
            // Update content on submit
            ConfirmFormExit.formSubmitting = true;
            ConfirmFormExit.contentOnLoad = ConfirmFormExit.serializeForm();
          });



          if (!ConfirmFormExit.initialized){
            // Load form content on first action
            ConfirmFormExit.contentOnLoad = ConfirmFormExit.serializeForm();
            ConfirmFormExit.initialized = true;
          }

          // Unload event
          jQuery(window).off("beforeunload", ConfirmFormExit.handleBeforeunload).on("beforeunload", ConfirmFormExit.handleBeforeunload);

          // Backbutton
          jQuery(window).off("popstate", ConfirmFormExit.handlePopstate).on("popstate", ConfirmFormExit.handlePopstate);

          // Turbo
          jQuery(document).off("page:before-change turbo:before-visit", ConfirmFormExit.handleTurboVisit).on("page:before-change turbo:before-visit", ConfirmFormExit.handleTurboVisit);
           

        });
    },

    handleBeforeunload: function (event) {
      if (!ConfirmFormExit.formSubmitting && ConfirmFormExit.contentChanged()) {
        event.returnValue = I18n.t('confirm_exit_without_saving');
        return event.returnValue;
      } else {
        return undefined;
      }
    },

    handleTurboVisit: function () {
      if (!ConfirmFormExit.formSubmitting && ConfirmFormExit.contentChanged()) {
        var c = confirm(I18n.t('confirm_exit_without_saving'));
        if (c) {
          jQuery(document).off("page:before-change turbo:before-visit", ConfirmFormExit.handleTurboVisit);
          jQuery(window).off("beforeunload", ConfirmFormExit.handleBeforeunload);
        }
        return c;
      }

      return true;
    },

    handlePopstate: function (event) {
      if (!ConfirmFormExit.formSubmitting && ConfirmFormExit.contentChanged()) {
        var c = confirm(I18n.t('confirm_exit_without_saving'));
        if (c) {
          jQuery(document).off("page:before-change turbo:before-visit", ConfirmFormExit.handleTurboVisit);
          jQuery(window).off("beforeunload", ConfirmFormExit.handleBeforeunload);
          // history.back();
        } else {
          // Stay on the current page.
          history.pushState(null, null, window.location.pathname);
        }
      } else {
        jQuery(document).off("page:before-change turbo:before-visit", ConfirmFormExit.handleTurboVisit);
        jQuery(window).off("beforeunload", ConfirmFormExit.handleBeforeunload);
      }
    },

    reload: function() {
      ConfirmFormExit.contentOnLoad = ConfirmFormExit.serializeForm();
    },

    contentChanged: function() {
      // console.log("contentChanged: " + (ConfirmFormExit.initialized && jQuery('form.confirm-exit').length > 0 && ConfirmFormExit.contentOnLoad !== ConfirmFormExit.serializeForm()))
      // If serializeForm() == '' then form has been published, and exit should not be confirmed
      return (ConfirmFormExit.initialized && jQuery('form.confirm-exit').length > 0 && ConfirmFormExit.contentOnLoad !== ConfirmFormExit.serializeForm() && ConfirmFormExit.serializeForm() != '');
    },

    serializeForm: function() {
      return jQuery('form.confirm-exit input[type!="hidden"][name!="status"]').serialize();
    }

}

window.AutoSave = AutoSave;
window.ConfirmFormExit = ConfirmFormExit;
